import { Component, HostListener, OnInit } from '@angular/core';
import { AuthService } from '../auth/auth.service';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.css'],
    standalone: false
})
export class DashboardComponent implements OnInit {
  constructor(private authService: AuthService) { }
  username = JSON.parse(localStorage.getItem('current-user'));
  menuActive = true;
  userMenuOpen = false;
  items: any[];

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.user-menu')) {
      this.userMenuOpen = false;
    }
  }

  ngOnInit(): void {
    this.items = [
      {
        value: 'Logout',
      },
    ];
  }

  onMenuButtonClick(): void {
    this.menuActive = !this.menuActive;
  }

  onMaskClick(): void {
    this.menuActive = false;
  }

  logout(): void {
    this.authService.logout();
  }
}
